export const scrollToId = (id: string, offset: number = 70): void => {
    const element = document.getElementById(id);
    if (!element) return;
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
    const scrollPosition = elementTop - offset;
    window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth',
    });
};